import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { I18n } from 'components/translate';
import { PropTypes } from 'prop-types';

import './ConfigList.scss';

export default class ConfigListItem extends Component {
  static propTypes = {
    item: PropTypes.object,
    key: PropTypes.string,
    params: PropTypes.object,
    large: PropTypes.bool
  };

  get label() {
    const { item, params } = this.props;
    const data = { ...params };

    if (item.streamingPrice) {
      data.streamingPrice = item.streamingPrice;
    }

    return item.data || item.streamingPrice ? (
      <I18n html label={item.label} data={data} />
    ) : (
      <I18n html label={item.label} />
    );
  }

  render() {
    const { item, key } = this.props;
    const showIcon = !item.detail;

    return (
      <li key={key}>
        {showIcon && <FontAwesomeIcon icon={['fas', 'square-check']} />}
        {this.label}
      </li>
    );
  }
}
